import app from './app';

app.mount();
